module.exports = __webpack_public_path__ + "static/media/IconDownload.0aa014de.svg";